import React, { useState, useEffect } from "react";
import { Modal, DatePicker, Button } from "antd";
import moment from "moment";
import "./dateRangePopup.css"; 

const DateRangePopup = ({ visible, onOk, onCancel, initialStart, initialEnd }) => {
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  // Sync with initial values when modal opens or props change
  useEffect(() => {
    if (visible) {
      setStart(initialStart || null);
      setEnd(initialEnd || null);
    }
  }, [visible, initialStart, initialEnd]);

  const handleOk = () => {
    onOk(start, end);
    setStart(null);
    setEnd(null);
  };

  const handleClear = () => {
    setStart(null);
    setEnd(null);
    onOk(null, null); 
  };

  const handleCancel = () => {
    setStart(null);
    setEnd(null);
    onCancel();
  };

  return (
    <Modal
      open={visible}
      title={
        <div style={{
          fontSize: 18,
          fontWeight: 600,
          color: '#1a1a1a',
          letterSpacing: '-0.01em'
        }}>
          Select Date Range
        </div>
      }
      onCancel={handleCancel}
      footer={[
        <Button
          key="clear"
          style={{
            borderColor: '#d9d9d9',
            color: '#595959',
            fontWeight: 600,
            height: 40,
            paddingLeft: 24,
            paddingRight: 24,
            borderRadius: 6
          }}
          onClick={handleClear}
        >
          Clear
        </Button>,
        <Button
          key="apply"
          type="primary"
          className="ok-btn-custom"
          onClick={handleOk}
        >
          Apply
        </Button>
      ]}
      width={560}
      styles={{
        header: {
          paddingBottom: 16,
          borderBottom: '1px solid #f0f0f0',
          marginBottom: 24
        },
        body: {
          paddingTop: 24
        },
        footer: {
          marginTop: 24,
          paddingTop: 20,
          borderTop: '1px solid #f0f0f0'
        }
      }}
    >
      <div style={{ display: "flex", gap: 20 }}>
        <div style={{ flex: 1 }}>
          <div style={{
            marginBottom: 10,
            fontWeight: 600,
            fontSize: 12,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            color: '#262626'
          }}>
            Start Date
          </div>
          <DatePicker
            placeholder="Select start date"
            value={start}
            onChange={date => setStart(date)}
            disabledDate={d => d && d > moment().endOf("day")}
            style={{
              width: "100%",
              height: 44,
              borderRadius: 6,
              borderColor: start ? '#000' : '#d9d9d9'
            }}
            format="MMM DD, YYYY"
          />
        </div>

        <div style={{ flex: 1 }}>
          <div style={{
            marginBottom: 10,
            fontWeight: 600,
            fontSize: 12,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            color: '#262626'
          }}>
            End Date
          </div>
          <DatePicker
            placeholder="Select end date"
            value={end}
            onChange={date => setEnd(date)}
            disabledDate={d => {
              if (!d) return false;
              if (d > moment().endOf("day")) return true;
              if (start && d < start.startOf("day")) return true;
              return false;
            }}
            style={{
              width: "100%",
              height: 44,
              borderRadius: 6,
              borderColor: end ? '#000' : '#d9d9d9',
              backgroundColor: '#fff'
            }}
            format="MMM DD, YYYY"
          />
        </div>
      </div>

      {(start || end) && (
        <div style={{
          marginTop: 24,
          padding: 16,
          backgroundColor: '#fafafa',
          border: '1px solid #e8e8e8',
          borderRadius: 6,
          fontSize: 14
        }}>
          <div style={{
            fontSize: 11,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            color: '#8c8c8c',
            marginBottom: 8
          }}>
            Selected Range
          </div>
          <div style={{
            color: '#1a1a1a',
            fontWeight: 500,
            fontSize: 15
          }}>
            {start?.format("MMM DD, YYYY") || "Not selected"}
            <span style={{ margin: '0 8px', color: '#bfbfbf' }}>→</span>
            {end?.format("MMM DD, YYYY") || "Not selected"}
          </div>
          {start && end && (
            <div style={{
              marginTop: 6,
              color: '#595959',
              fontSize: 13
            }}>
              {end.diff(start, 'days') + 1} days selected
            </div>
          )}
        </div>
      )}
    </Modal>
  );
};

export default DateRangePopup;
